export default function whatsappShare(){
  const desc = $('meta[property="og:description"]').attr('content');
  
  $('[data-whatsappshare]').attr('href', `https://api.whatsapp.com/send?text=${desc} ${encodeURIComponent(window.location.href)}`)
}